import styled from "styled-components";
import {Col, Row} from "antd";

export const AuthPage = styled(Row)`
  height: 100%;
`

export const LeftCol = styled(Col)`
  background-color: #E4F4FD;
  display: flex;
  justify-content: center;
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain;
`

export const RightCol = styled(Col)`
  padding: 64px;
  background-color: #FFF;
`